import React from 'react';

import styles from './ProportionateDistributionMethod.module.scss';
import toolTip from '../../assets/images/Tooltip.svg';
import MyToolTip from '../../components/Shared/MyToolTip/MyToolTip';

import Phone from '../../components/Phone/Phone';
import ModalLink from '../../components/Shared/Modal/ModalLink/ModalLink';
import config from '../../config/config';
import { EXIT_MODAL } from '../../redux/modules/modals/modals.module';
import {
  TOLL_FREE_NUMBER,
  RMD_NUMBER,
  PURCHASE_BLOCKED,
  RETURN_MAIL,
  PENDING,
  TEMPORARILY_STOP_TRANSFER,
  UNAVAILABLE_ONLINE,
  IN_ELIGIBLE,
  BANK_NOT_LINKED,
  PENDING_BANK_ASSOCIATION,
  ZERO_BALANCE,
  EXISTING_AUTO_EXCHANGE,
  EXISTING_AUTO_SELL,
  EXISTING_AUTO_EXCHANGE_SELL,
} from '../../settings/settings';
import {
  calculateAndFormatUnixDates,
  futureDate,
} from '../../utils/date-utils';

function DisabledText({
  lockNote,
  effectiveDate,
  agreementNumber,
  hasRmdEligibleFunds,
  hasAllUnavailableOnline,
}) {
  let disabledText = '';
  switch (lockNote) {
    case PENDING_BANK_ASSOCIATION:
      disabledText = (
        <div
          className={`${styles['restricted-address']} ${
            hasRmdEligibleFunds && styles['restricted-address-in-center']
          }`}
        >
          <span className={styles['disable-text']}>Stop Transfer</span>
          <MyToolTip
            id={'disable-img'}
            descriptionTitle={
              <div className={styles['tool-tip-header']}>Stop Transfer</div>
            }
            descriptionBody={
              <div>
                 A stop transfer temporarily restricts the movement of funds in
                and out of an account. A stop transfer can be initiated by a
                client or by T. Rowe Price for reasons related to security
                and/or privacy.{' '}
                <a
                  href={`${config.url}/personal-investing/help/contact/index.html`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles['contact-us-link']}
                >
                  Contact us
                </a>{' '}
                to learn more. 
              </div>
            }
            popOutPlacement="top"
            callerNode={
              <img
                className={styles['disable-img']}
                src={toolTip}
                alt="tool tip icon"
              />
            }
            maxNoteWidth="300px"
          />{' '}
          {!hasRmdEligibleFunds && (
            <>
              {' '}
              - Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> for assistance.
            </>
          )}
        </div>
      );
      break;
    case PURCHASE_BLOCKED:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            Transactions Currently Restricted{' '}
          </span>
          -{' '}
          <a
            href={`${config.url}/personal-investing/help/contact/index.html`}
            rel="noopener noreferrer"
            target="_blank"
            className={styles['contact-us-link']}
          >
            Contact us
          </a>{' '}
          for assistance.
        </div>
      );
      break;
    case RETURN_MAIL:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            Address Marked as Undeliverable
          </span>
          {'  '}-{'  '}
          <ModalLink
            link={<div className="error-link">Change address</div>}
            linkStyle="link"
            modalProps={{
              url: `${config.url}/usis/my-accounts/profile/contact-information`,
              description:
                'Your information will not be saved and you will not be able to mail in an RMD to your new address until after the 15 day holding period.',
            }}
            modalName={EXIT_MODAL}
          />
        </div>
      );
      break;
    case PENDING:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            Address Pending Verification
          </span>{' '}
          - Available on{' '}
          {calculateAndFormatUnixDates(futureDate(effectiveDate, 15))}
        </div>
      );
      break;
    case TEMPORARILY_STOP_TRANSFER:
      disabledText = (
        <div
          className={`${styles['restricted-address']} ${
            hasRmdEligibleFunds && styles['restricted-address-in-center']
          }`}
        >
          <span className={styles['disable-text']}>Stop Transfer</span>
          <MyToolTip
            id={'disable-img'}
            descriptionTitle={
              <div className={styles['tool-tip-header']}>Stop Transfer</div>
            }
            descriptionBody={
              <div>
                 A stop transfer temporarily restricts the movement of funds in
                and out of an account. A stop transfer can be initiated by a
                client or by T. Rowe Price for reasons related to security
                and/or privacy.{' '}
                <a
                  href={`${config.url}/personal-investing/help/contact/index.html`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles['contact-us-link']}
                >
                  Contact us
                </a>{' '}
                to learn more. 
              </div>
            }
            popOutPlacement="top"
            callerNode={
              <img
                className={styles['disable-img']}
                src={toolTip}
                alt="tool tip icon"
              />
            }
            maxNoteWidth="300px"
          />{' '}
          {!hasRmdEligibleFunds && (
            <>
              - Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> for assistance.
            </>
          )}
        </div>
      );
      break;
    case UNAVAILABLE_ONLINE:
      disabledText = (
        <div
          className={`${styles['restricted-address']} ${
            !hasAllUnavailableOnline && styles['restricted-address-in-center']
          }`}
        >
          <span className={styles['disable-text']}>Unavailable Online</span>
          <MyToolTip
            id={`unavailable-${agreementNumber}`}
            descriptionTitle={
              <div className={styles['tool-tip-header']}>
                Unavailable Online
              </div>
            }
            descriptionBody={
              <div>
                This account is not currently set up for online/phone
                redemptions. You can{' '}
                <a
                  href={`${config.url}/personal-investing/help/contact/index.html`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles['contact-us-link']}
                >
                  contact us
                </a>{' '}
                to enable redemptions on this and other accounts.
              </div>
            }
            popOutPlacement="top"
            callerNode={
              <img
                className={styles['disable-img']}
                src={toolTip}
                alt="tool tip icon"
              />
            }
            maxNoteWidth="300px"
          />{' '}
          {hasAllUnavailableOnline && (
            <>
              - Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> for assistance.
            </>
          )}
        </div>
      );
      break;
    case BANK_NOT_LINKED:
      disabledText = (
        <div
          className={`${styles['restricted-address']} ${styles['restricted-address-in-center']}`}
        >
          <span className={styles['disable-text']}>Bank Not Linked</span>
          <MyToolTip
            id={'disable-img'}
            descriptionTitle={
              <div className={styles['tool-tip-header']}>Bank Not Linked</div>
            }
            descriptionBody={
              <div>
                This fund is not connected to the bank you selected. Click here
                to{' '}
                <a
                  className={styles['link']}
                  href="https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts"
                  target="_blank"
                >
                  link this bank
                </a>
                .
              </div>
            }
            popOutPlacement="top"
            callerNode={
              <img
                className={styles['disable-img']}
                src={toolTip}
                alt="tool tip icon"
              />
            }
            maxNoteWidth="300px"
          />{' '}
        </div>
      );
      break;
    case ZERO_BALANCE:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>Account Closed</span> - Call{' '}
          <Phone phoneNumber={TOLL_FREE_NUMBER} /> for assistance.
        </div>
      );
      break;
    case EXISTING_AUTO_EXCHANGE:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            One Automatic Exchange Permitted Per Investment{' '}
          </span>
          <ModalLink
            link={
              <div className="error-link">Review automatic transactions</div>
            }
            linkStyle="link"
            modalProps={{
              url: `${config.url}/usis/transactions/automatic`,
            }}
            modalName={EXIT_MODAL}
          />
        </div>
      );
      break;
    case EXISTING_AUTO_SELL:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            One Automatic Sell Permitted Per Investment{' '}
          </span>
          <ModalLink
            link={
              <div className="error-link">Review automatic transactions</div>
            }
            linkStyle="link"
            modalProps={{
              url: `${config.url}/usis/transactions/automatic`,
            }}
            modalName={EXIT_MODAL}
          />
        </div>
      );
      break;
    case EXISTING_AUTO_EXCHANGE_SELL:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>
            One Automatic Exchange or Sell Permitted Per Investment{' '}
          </span>
          <ModalLink
            link={
              <div className="error-link">Review automatic transactions</div>
            }
            linkStyle="link"
            modalProps={{
              url: `${config.url}/usis/transactions/automatic`,
            }}
            modalName={EXIT_MODAL}
          />
        </div>
      );
      break;
    case IN_ELIGIBLE:
      disabledText = (
        <div className={styles['restricted-address']}>
          <span className={styles['disable-text']}>Not Eligible</span>
        </div>
      );
      break;
    default:
      disabledText = '';
      break;
  }
  return disabledText;
}

export default DisabledText;
